import { GridColumnVisibilityModel } from '@mui/x-data-grid-premium';
import { LocalStorage } from '@shared/constants';
import { getTogglableDataGridColumns } from '@shared/utils';
import { GridColDef } from '@mui/x-data-grid-premium';

export const getColumnVisibilityStorageKey = (tableId: string): string => {
  return `${LocalStorage.DATA_GRID_COLUMN_VISIBILITY}${tableId}`;
};

export const saveColumnVisibilityToLocalStorage = (
  tableId: string,
  columns: readonly GridColDef[],
  columnVisibilityModel: GridColumnVisibilityModel
): void => {
  const toggableColumns = getTogglableDataGridColumns(columns);
  const storageKey = getColumnVisibilityStorageKey(tableId);

  const visibilityModel: GridColumnVisibilityModel = {};
  toggableColumns.forEach((field) => {
    if (columnVisibilityModel[field] !== undefined) {
      visibilityModel[field] = columnVisibilityModel[field];
    }
  });

  localStorage.setItem(storageKey, JSON.stringify(visibilityModel));
};

export const getColumnVisibilityFromLocalStorage = (
  tableId: string,
  columns: readonly GridColDef[]
): GridColumnVisibilityModel => {
  const storageKey = getColumnVisibilityStorageKey(tableId);
  const saved = localStorage.getItem(storageKey);

  if (!saved) {
    return {};
  }

  try {
    const parsed: GridColumnVisibilityModel = JSON.parse(saved);
    return parsed;
  } catch {
    return {};
  }
};
